class RecentlyViewedTracker extends HTMLElement {
  constructor() {
    super();

    this.storageKey = 'recentlyViewed'; // Key used in localStorage
    this.handle = null;
  }

  connectedCallback() {
    this.handle = this.getAttribute('data-handle');
    this.limit = Number(this.getAttribute('data-limit') || 10);

    if (!this.handle) return;

    this.track(this.handle);
    this._onPageShow = (event) => this.onPageShow(event);

    // Handle Back-Forward Cache (bfcache) navigation
    window.addEventListener('pageshow', this._onPageShow);
  }

  disconnectedCallback() {
    window.removeEventListener('pageshow', this._onPageShow);
  }

  onPageShow(event) {
    if (event.persisted) {
      // Page was restored from bfcache
      this.track(this.handle);
    }
  }

  // Track a product handle
  track(handle) {
    // 1. Get existing data
    let recent = [];
    try {
      const stored = localStorage.getItem(this.storageKey);
      recent = stored ? JSON.parse(stored) : [];
    } catch (e) {
      // If accessing or parsing localStorage fails, fall back to an empty list
      recent = [];
    }
    recent = [handle, ...recent.filter((h) => h !== handle)].slice(
      0,
      this.limit
    ); // 2. Add new handle to the front, remove duplicates, and limit length

    // Save back to localStorage
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(recent));
    } catch (e) {
      // Ignore storage errors to avoid breaking the page
    }

    // Dispatch an event so the "List" component can update in real-time if on the same page
    window.dispatchEvent(new CustomEvent('recently-viewed-updated'));
  }
}

customElements.define('recently-viewed-tracker', RecentlyViewedTracker);
